import React, { useContext } from 'react'
import { WorkModel } from '@Entities/work/work'
import WorkItemWrapper from '@Components/WorkItem/index-wrapper'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface RegistrationDraftsTableProp {
    openDeleteModal: (typeAll: boolean, title?: string, id?: number) => void
}

const RegistrationDraftsTable = (props: RegistrationDraftsTableProp) => {
    const { rightsholderStore, workSearchStore } = useContext<RootStore>(StoresContext)
    const { openDeleteModal } = props
    const workDrafts = workSearchStore.worksDraftsRightsHolder

    return (
        <section className="items-container">
            {workDrafts?.works.map((item: WorkModel, index: number) => (
                <WorkItemWrapper
                    key={item.id ? item.id : index}
                    data={item}
                    rightsHolderId={rightsholderStore.currentRightsholderId}
                    draftType
                    handleDeleteDraft={() => openDeleteModal(false, item.title, item.id ? item.id : index)}
                />
            ))}
            {workDrafts && workDrafts.count < 1 && <p className="small no-results">No results</p>}
        </section>
    )
}

export default observer(RegistrationDraftsTable)
